import React, { useEffect, useState } from "react";
import { BookOpenCheck } from "lucide-react";
import api from "../services/api";
import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover";
import { btnGhost, inputCls } from "./ui";

export const appendCitation = (text, cite) => {
  const t = (text || "").replace(/\s+$/, "");
  return t ? `${t} ${cite}` : cite;
};

export function RuleCiteButton({ onCite, testId = "cite-rule-btn" }) {
  const [open, setOpen] = useState(false);
  const [rules, setRules] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => {
    if (open && !rules.length) api.get("/ujms/rules").then((r) => setRules(r.data)).catch(() => {});
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const ql = q.trim().toLowerCase();
  const filtered = rules.filter((r) => !ql || `${r.section} ${r.title} ${r.summary}`.toLowerCase().includes(ql)).slice(0, 30);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className={btnGhost} data-testid={testId}>
          <BookOpenCheck className="w-3.5 h-3.5" /> Cite Rule
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[420px] p-2 z-[100]" align="start">
        <input autoFocus className={inputCls} placeholder="Search rules… e.g. GO 1.2, Deputy Chief" value={q}
          onChange={(e) => setQ(e.target.value)} data-testid={`${testId}-search`} />
        <div className="max-h-60 overflow-y-auto mt-1.5 divide-y divide-slate-100">
          {filtered.map((r) => (
            <button key={r.section} type="button"
              className="w-full text-left px-2 py-1.5 hover:bg-blue-50 rounded-sm block"
              onClick={() => { onCite(`${r.section} (${r.title})`); setOpen(false); setQ(""); }}
              data-testid={`${testId}-opt-${r.section.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}>
              <span className="font-mono text-xs font-semibold text-blue-900">{r.section}</span>
              <span className="text-xs text-slate-600 ml-1.5">{r.title}</span>
            </button>
          ))}
          {!filtered.length && <div className="text-xs text-slate-400 px-2 py-3">No rules match.</div>}
        </div>
      </PopoverContent>
    </Popover>
  );
}
